import React, {ReactNode} from "react";

import {GroupIcon} from "../icons/GroupIcon";

import "../ActiveUserStatusDot/ActiveUserStatusDot.css";
import "./ActiveUsers.css";

export interface ActiveUsersItem {
    id: string;
    name: string;
    avatar: ReactNode;
}

export interface ActiveUsersProps {
    users: ActiveUsersItem[];
    activeUsersCount: number;
    showHeader: boolean;
    headerTitle: string;
    emptyText: string;
    showEmpty: boolean;
}

export const ActiveUsers = ({
    users,
    activeUsersCount,
    showHeader,
    headerTitle,
    emptyText,
    showEmpty,
}: ActiveUsersProps) => {
    return (
        <div className="ActiveUsers">
            {showHeader ? (
                <ActiveUsersHeader
                    title={headerTitle}
                    activeUsersCount={activeUsersCount}
                />
            ) : null}
            <div className="ActiveUsers__content">
                {showEmpty ? (
                    <div className="ActiveUsers-empty">
                        {emptyText}
                    </div>
                ) : (
                    users.map((user) => (
                        <div className="ActiveUsers__name-block" key={user.id}>
                            <span className="ActiveUsers__avatar">
                                {user.avatar}
                                <span className="ActiveUsers__avatar-status ActiveUserStatusDot" aria-hidden="true"/>
                            </span>
                            <div className="ActiveUsers__name body-large">
                                {user.name}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export interface ActiveUsersHeaderProps {
    title: string;
    activeUsersCount: number;
}

export const ActiveUsersHeader = ({title, activeUsersCount}: ActiveUsersHeaderProps) => {
    return (
        <div className="ActiveUsers-header">
            <div className="ActiveUsers-title body-large">
                {title}
            </div>
            <ActiveUsersCount count={activeUsersCount}/>
            <div className="ActiveUsersIcon">
                <GroupIcon size={20}/>
            </div>
        </div>
    );
};

export const ActiveUsersCount = ({count}: {count: number}) => {
    return (
        <div>
            <div className="ActiveUsers-count headline-large-bold">
                {count}
            </div>
        </div>
    );
};
